import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/MagicJump/index.tsx");
